import { app } from 'app/providers/FirebaseProvider/ui/FirebaseProvider'
import { getAuth } from 'firebase/auth'
import { loadLegacyFirestore } from 'shared/firebase/loadLegacyFirebase'
import { backendForFirebaseUser } from './backendForFirebaseUser'

export const fetchFriendProfiles = async (friendIds = []) => {
    const backend = backendForFirebaseUser(getAuth(app).currentUser)
    if (backend) {
        const result = await backend.getFriends()
        return result.friends
    }

    const { collection, db, getDocs, query, where } =
        await loadLegacyFirestore()
    const snapshots = await Promise.all(
        friendIds.map((id) =>
            getDocs(query(collection(db, 'Auth'), where('id', '==', id)))
        )
    )

    return snapshots.flatMap((snapshot) =>
        snapshot.docs.map((document) => ({ ...document.data() }))
    )
}
